import { render, staticRenderFns } from "./ScheduleCalenderItem.vue?vue&type=template&id=740d1bcb&"
import script from "./ScheduleCalenderItem.vue?vue&type=script&lang=js&"
export * from "./ScheduleCalenderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Button/index.vue').default})
